/*
 * Module for managing client html templates to avoid putting html in JavaScript files
 */

rs.module("ui/framework/client-templates", [],

    function () {

        var templates = {};
        var counter = 1;

        //
        // Register a client template
        //
        function register(key, base64) {

            // See if this is already registered
            if (templates[key]) {

                // It's ok to re-register a template of the same name if its actually the same template.  This could happen if a template was stored
                // in a script that is in an element that is added to the DOM multiple times.
                if (templates[key].base64 != base64) {
                    throw new Error("Template '" + key + "' has already been registered.");
                }
                else {
                    return;
                }
            }

            templates[key] = {
                key: key,
                base64: base64,
                decoded: null
            };
        }

       //
       // Render the given template with the specified data replacements
       //
       function render(key, data) {

           var template = templates[key];

           if (!template) {
                throw new Error("Template '" + key + "' has not been registered.");
           }

           if (!template.decoded) {
               template.decoded = atob(template.base64);
           }

           // This maintains unique names as expected when using the "Unique" function from LrsRazorPage no
           // matter how many times the client template is actually duplicated by script. The "__counter" property
           // name must stay in sync with ClientTemplateUniqueNameFeature.counterName
           data = _.extend({}, data, { __counter: "render" + counter++ });

           return Mustache.render(template.decoded, data);
        }

        // Exported public API
        var exports = {
            register: register,
            render: render
        };

        return exports;
    }
);